<template>
    <div>
        <div style="width:100%;height:80%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;">
            <div style="text-align:left;">
                <div class="col-xs-12"><h3>{{ lang.postList.add }}</h3></div>
                <div class="col-xs-12 agx-col-head">{{lang.postEditor.title}}</div>
                <div class="col-xs-12 agx-col-msg">
                    <input class="form-control" style="width:100%;" type="text" name="title" v-model="newPostData.title" />
                </div>
                <div class="col-xs-12 agx-col-head">{{ lang.postEditor.content }}</div>
                <div class="col-xs-12 agx-col-msg">
                    <textarea class="form-control" style="width:100%;height:60px;" name="textMsg" v-model="newPostData.textMsg"></textarea>
                </div>
            </div>
            <br />
            <div class="col-xs-12" style="text-align:right;">
                <input type="button" :value="lang.common.add" class="btn btn-primary" @click="addPost" />
            </div>
        </div>
    </div>
</template>
<script>
    import apis from '../api/extApi.js';

    export default {
        props: {
            "userId": String,
            "parentId": { type: String, default: null }
        },
        computed: {
            lang: function () {
                return this.$store.getters.lang;
            }
        },
        data: function () {
            return {
                apiClient: apis.api,
                newPostData: { title: null, textMsg: null, userId: null, parentId: null },
                isAddingPost: false
            }
        },
        methods: {
            addPost: function () {
                this.newPostData.userId = this.userId;
                this.newPostData.parentId = this.parentId;
                this.apiClient.addPostPrms(this.newPostData).done((ret) => {
                    this.isAddingPost = false;
                    this.$emit("onadded",ret.value);
                });
            }
        },
        created: function () {
            
        }
    }
</script>